module.exports = __webpack_public_path__ + "static/media/roadmap-left-bg.fde8de56.svg";